"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var dom_helpers_1 = require("../../util/dom-helpers");
function isBody(node) {
    return node && node.tagName.toLowerCase() === 'body';
}
function bodyIsOverflowing(node) {
    var doc = dom_helpers_1.ownerDocument(node);
    var win = dom_helpers_1.getWindow(doc);
    var fullWidth = win.innerWidth;
    // Support: ie8, no innerWidth
    if (!fullWidth) {
        var documentElementRect = doc.documentElement.getBoundingClientRect();
        fullWidth = documentElementRect.right - Math.abs(documentElementRect.left);
    }
    return doc.body.clientWidth < fullWidth;
}
function isOverflowing(container) {
    var win = dom_helpers_1.getWindow(container);
    return win || isBody(container)
        ? bodyIsOverflowing(container)
        : container.scrollHeight > container.clientHeight;
}
exports.isOverflowing = isOverflowing;
